import { render, staticRenderFns } from "./SettingStaffEdit.vue?vue&type=template&id=53173610"
import script from "./SettingStaffEdit.vue?vue&type=script&lang=js"
export * from "./SettingStaffEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports